import { render, staticRenderFns } from "./UserDataTable.vue?vue&type=template&id=3e31187c&"
import script from "./UserDataTable.vue?vue&type=script&lang=js&"
export * from "./UserDataTable.vue?vue&type=script&lang=js&"
import style0 from "./UserDataTable.vue?vue&type=style&index=0&id=3e31187c&prod&language=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports